
import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';
import SignIn from '../pages/SignIn';
import Home from '../pages/Home';

import EsqueceuSuaSenha from '../pages/SignIn/EsqueceuSuaSenha';
import MeuPrimeiroAcesso from '../pages/SignIn/MeuPrimeiroAcesso';
import NovaSenha from '../pages/SignIn/NovaSenha';

import MinhaConta from '../pages/MinhaConta';
import Fatura from '../pages/Fatura';
import Contato from '../pages/Contato';
import Contrato from '../pages/Contrato';
import SolicitarAcesso from '../pages/SolicitarAcesso';
import CadastrarSenha from '../pages/CadastrarSenha';
import SelectionCompany from '../pages/SelecaoEmpresa';
import MaintenancEpref from '../pages/SelecaoEmpresa/components/Manutencao/Preference';
import MaintenancFaktory from '../pages/SelecaoEmpresa/components/Manutencao/Faktory';

const Routes: React.FC = () => (
    <Switch>
        {/* Rotas Publicas */}
        <Route path="/" component={SelectionCompany} exact  />
        <Route path="/Preference" component={MaintenancEpref} exact  />
        <Route path="/Faktory" component={MaintenancFaktory} exact  />
        <Route path="/Alumisoft/Login" component={SignIn} exact  />
        <Route path="/Alumisoft/esqueceuSuaSenha" component={EsqueceuSuaSenha} exact  />
        <Route path="/Alumisoft/meuPrimeiroAcesso/:pId" component={MeuPrimeiroAcesso} exact  />
        <Route path="/Alumisoft/novaSenha/:pId" component={NovaSenha} exact  />
        <Route path="/Alumisoft/SolicitarAcesso/" component={SolicitarAcesso} exact  />
        <Route path="/Alumisoft/CadastrarSenha/" component={CadastrarSenha} exact  />

        {/* Rotas Privadas */}
        <Route path="/Alumisoft/home" component={Home} isPrivate  />
        <Route path="/Alumisoft/minhaConta" exact component={MinhaConta} isPrivate  /> 
        <Route path="/Alumisoft/contratos" exact component={Contrato} isPrivate  /> 
        <Route path="/Alumisoft/faturas" exact component={Fatura} isPrivate  /> 
        <Route path="/Alumisoft/contato" exact component={Contato} isPrivate  /> 
    </Switch>
)

export default Routes;